class UserCompletionFullModalController {
    
    constructor() {
        this.template = Handlebars.compile($("#userCompletionFullModal").html());
        this.menuTemplate = Handlebars.compile($("#fullModalMenu").html());
    };

    draw(){
        api.getDetailedUserCompletion(world.token, this.onCategoriesInfoResponse.bind(this));
    };

    onCategoriesInfoResponse(response) {
        if (response.success) {
            let correctPercent = response.result.correct_answers/response.result.total_questions*100;
            let incorrectPercent = response.result.incorrect_answers/response.result.total_questions*100;
            let pendingQuestions = parseInt(response.result.total_questions) - (parseInt(response.result.correct_answers) + parseInt(response.result.incorrect_answers));

            baseController.resetStackableOrder();
            baseController.stackSimpleMenu({ title: 'TR_MI_COMPLETITUD', isCompleteScreen: true, world: world, user: user }, this.menuTemplate);

            var context = { world: world, user: user, completeInfo: response['result'], correctPercent: correctPercent,
                incorrectPercent: incorrectPercent, pendingQuestions: pendingQuestions };
            baseController.stackSimpleContent(this.template, context);

            $(".category-completion-list-element").click(function(){
                api.createNewGame(world.token, $(this).data("id"), {"name": $(this).data("name"), "icon": $(this).data("icon"), "color": $(this).data("color")});
            });

            let height = 40;

            if ($(window).width() <= 420) {
                height = 30;
            }

            $('.category-completion-name h3').dotdotdot({
                height: height,
                watch: 'true',
                truncate: 'letter'
            });
        }
    }
}
